import React from 'react'
import {Button} from 'reactstrap'

import useFormField from '../hooks/useFormField'

const ResetButton = (props) => {
  const {
    isDisabled: isButtonDisabled,
    formContext: {dirty},
  } = useFormField(props)

  const isDisabled = isButtonDisabled || !dirty

  return <Button {...props} disabled={isDisabled} type="reset" value={null} />
}

ResetButton.propTypes = {}

export default ResetButton
